<template>
  <div class="w-full">
    <div class="w-full min-h-[260px] relative">
      <div ref="context" class="h-full w-full relative">
        <div class="relative max-w-xl">
          <input
            type="text"
            v-model="query"
            :placeholder="dataLocales.data.placeholder"
            class="h-11 w-full rounded-sm border border-gray-200 focus:border-white focus:drop-shadow-md px-4 focus:outline-none"
            :class="{
              'border border-danger border-dashed': error,
              ' border-gray-300': !error,
            }"
            @focus="focus = true"
          />
          <IconsLoadingDecorator
            v-if="loading"
            class="w-6 absolute top-2 right-1"
          />
        </div>
        <TransitionRoot
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          :show="focus"
        >
          <div
            class="absolute z-50 max-w-xl max-h-96 w-full left-0 overflow-auto bg-white text-base drop-shadow-md ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
          >
            <ul>
              <li
                v-for="place in places"
                class="p-2 hover:bg-gray-100 cursor-pointer truncate"
                @click.prevent="SelectPlace(place)"
              >
                {{ place.name }} -
                <span class="text-gray-400 text-[13px]">{{
                  place.address
                }}</span>
              </li>
            </ul>
          </div>
        </TransitionRoot>
      </div>
      <div class="mt-4" v-if="place">
        <div class="p-4 rounded-md bg-white drop-shadow-sm w-fit">
          <p><b>Name</b> : {{ place?.name }}</p>
          <p><b>Address</b> : {{ place?.address }}</p>
        </div>
        <!-- <PartialsGoogleMap ref="map" :place="place" @UpdatePosition="UpdatePosition" /> -->
      </div>
    </div>
    <ToolsButtonCreate @generate="generate" />
  </div>
</template>
<script lang="ts" setup>
import { TransitionRoot } from "@headlessui/vue";
import { watchDebounced } from "@vueuse/core";
import { useQrCreateStore } from "~/stores/qrcreate";
import { ref, onMounted, getCurrentInstance } from "vue";
import { onClickOutside } from "@vueuse/core";
import DataLocale from "~~/config/interface/DataLocale";
import { useLimit } from "~~/stores/limit";

const context = ref<HTMLElement>();
const dataLocales = new DataLocale([
  {
    locale: "en",
    placeholder: "Search locations on Google Maps",
  },
  {
    locale: "vi",
    placeholder: "Tìm kiếm địa điểm trên Google Maps",
  },
  {
    locale: "ja",
    placeholder: "Googleマップで場所を検索",
  },

  {
    locale: "zh",
    placeholder: "在Google地图上搜索地点",
  },

  {
    locale: "fr",
    placeholder: "Rechercher des lieux sur Google Maps",
  },
  {
    locale: "es",
    placeholder: "Buscar lugares en Google Maps",
  },
  {
    locale: "nl",
    placeholder: "Zoek locaties op Google Maps",
  },
  {
    locale: "de",
    placeholder: "Suche Standorte auf Google Maps",
  },
  {
    locale: "it",
    placeholder: "Cerca luoghi su Google Maps",
  },
  { locale: "pt", placeholder: "Pesquisar locais no Google Maps" },
]);
onClickOutside(context, (event) => {
  focus.value = false;
});

const error = ref(false);
const qrcreate = useQrCreateStore();
const qrstyle = useQrStyle();
const query = ref("");
const focus = ref(false);
interface Place {
  id: string;
  address: string;
  name: string;
}
const map = ref<HTMLElement>();
const places = ref<Array<Place> | []>([]);
const loading = ref(false);
const place = ref<Place | null>(null);

const validateData = () => {
  if (place.value) {
    qrcreate.map = place.value;
    return true;
  }
  error.value = true;
  return false;
};
const generate = async () => {
  if (validateData()) {
    await qrstyle.GenerateQrCode();
  }
};
const SelectPlace = (placelocale: Place) => {
  place.value = {
    name: placelocale.name,
    id: placelocale.id,
    address: placelocale.address,
  };
  query.value = "";
  focus.value = false;
  qrcreate.imageData = "";
};

// const UpdatePosition = (position: { lat: number; lng: number }) => {
//   place.value.place_id = "";
//   if (qrcreate.imageData) {
//     qrcreate.imageData = "";
//   }
// };
const { checkLimit } = useLimit();
const SearchPlace = () => {
  if (checkLimit("map")) {
    return;
  }
  loading.value = true;
  $fetch("/api/search_place", {
    method: "POST",
    body: {
      query: query.value,
    },
  })
    .then((res) => {
      loading.value = false;
      places.value = res;
    })
    .catch((err) => {
      loading.value = false;
    });
};

watchDebounced(
  query,
  () => {
    if (query.value && query.value.length > 2) {
      SearchPlace();
    }
  },
  { debounce: 1000, maxWait: 5000 }
);
</script>
